import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getAccessToken } from '../auth-session.util';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (getAccessToken()) {
    return true;
  }

  // BLK-36: bootstrapSession, not refreshSession. The app kicks off a restore at
  // boot; going straight to refreshSession here started a SECOND round-trip,
  // because by the time the guard runs the first has settled and cleared the
  // in-flight promise. bootstrapSession shares one attempt, and it also honours
  // the "has this browser ever had a session" flag instead of always asking.
  const restored = await authService.bootstrapSession();
  if (restored && getAccessToken()) {
    return true;
  }

  router.navigate(['/auth/login'], { queryParams: { redirectTo: state.url } });
  return false;
};
